import { Img } from "components";
import { useNavigate } from "react-router-dom";
import { CSSProperties } from "react";
import { useRef, useState, useEffect } from "react";
import AvatarVideo from "../components/AvatarVideo";
import { useGlobalState } from "components/GlobalState";
import Wrapper from "../components/Wrapper";
import CircularRightArrow from "assets/images/CircularRightArrow.json";
import Lottie from "lottie-react";

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/soomuch_demo_intro.mp4" }
]

// Updated card style to match the design - square shape with clean styling
const cardStyle: CSSProperties = {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    borderRadius: '1rem',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%', // Responsive height    
};

const LIST = [
    {
        "title": "Funded by *Microsoft*",
        "image": "images/soomuch-demo/Microsoft.svg"
    },
    {
        "title": "Aligned with *PM Modi’s* Digital India Vision",
        "image": "images/soomuch-demo/modi.png"
    },
    {
        "title": "*India’s First: Multilingual* School Communication",
        "image": "images/soomuch-demo/multilang.svg"
    },
    {
        "title": "*AI-Powered & Fully Automated* – No technical skills needed",
        "image": "images/soomuch-demo/aipowered.svg"
    },
    {
        "title": "*Up to ₹2.5 Crores* in Admission Growth",
        "image": "images/soomuch-demo/stockrising.svg"
    },
    {
        "title": "Up to *₹25 Lakhs Saved* from outdated school management software",
        "image": "images/soomuch-demo/coins.svg"
    },
    {
        "title": "4000+ Teaching Hours Saved through attendance & homework automation",
        "image": "images/soomuch-demo/clockwithtick.svg"
    },
    {
        "title": "*₹5 Lakhs Worth of FREE* and services and full application",
        "image": "images/soomuch-demo/free.svg"
    }
]

function wrapStrong(text) {
    const parts = text.split(/(\*[^*]+\*)/); // split by text wrapped in asterisks

    return parts.map((part, index) => {
        if (part.startsWith('*') && part.endsWith('*')) {
            return <span className="font-manropeB" key={index}>{part.slice(1, -1)}</span>; // remove asterisks and bold
        }
        return <span key={index}>{part}</span>;
    });
}

const Intro = () => {
    const [showModal, setShowModal] = useState(true);
    const [videoPlaying, setVideoPlaying] = useState(false);
    const videoRef = useRef(null);
    const { isMuted, language, setLanguage } = useGlobalState();

    // Control video playback based on modal state
    // useEffect(() => {
    //     if (!!videoRef.current) {
    //         if (!showModal && videoPlaying) {
    //             videoRef.current.muted = isMuted;
    //             videoRef.current.play();
    //         } else {
    //             videoRef.current.pause();
    //             videoRef.current.muted = isMuted;
    //         }
    //     }
    // }, [showModal, videoPlaying]);

    const navigate = useNavigate();
    return (
        <Wrapper
            textAboveTitle="India’s 1st AI-Powered Marketing Platform for Educational Institutions"
            title={<>Welcome to SOOMUCH Live Demo</>}
            // titleSize="text-[5vh]"
            description={<>Our mission to deliver the world’s best educational experience to every student and parent, <br />powered by AI and automation.</>}
            videoLinks={videoLinks}
            stepperNotRequired
            body={<>
                <div className="flex flex-col items-between justify-center text-center gap-[2.5vh]">
                    {/* <p className="text-[2vh] font-medium"><span className="font-manropeB">Our mission</span> to deliver the world’s best educational experience to every student and parent, powered by <br /> AI and automation.</p> */}
                    <div className="grid grid-cols-3 gap-[2.3vh]">
                        <div>
                            <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal">
                                Why Schools Trust Soomuch.AI
                            </h2>
                        </div>
                        <div></div>
                        <div>
                            <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal">
                                What You’ll Gain
                            </h2>
                        </div>
                        <div className="grid grid-cols-2 gap-[1.5vh]">
                            {LIST?.slice(0, 4)?.map((item, index) => <div key={"asdbasbdnasmdasd" + index} className="bg-[white] drop-shadow-2xl rounded-xl p-3 text-[#081B34] text-left space-y-4 min-h-[22vh]">
                                {index === 1 ? <div className="w-fit rounded-full bg-smd_white-light border-2 border-[#FBF1E7]">
                                    <Img src={item?.image} className="object-cover h-[5.4vh]" />
                                </div> : <div className="w-fit p-[1vh] rounded-full bg-smd_white-light border-2 border-[#FBF1E7]">
                                    <Img src={item?.image} className="object-cover h-[4vh]" />
                                </div>}
                                <h2 className="text-[2.2vh] text-[black]">{wrapStrong(item?.title)}</h2>
                            </div>)}
                        </div>
                        <div className="flex flex-col gap-[4vh] self-center mx-4 mb-10">
                            <div className="space-y-[1vh]">
                                <p className="text-[2vh] font-manropeSB">Please select language before starting demo</p>
                                <div className="flex gap-[2vh] items-center bg-[white] drop-shadow shadow-lg border-0 rounded-xl p-[1vh] text-[2.8vh]">
                                    <select className="text-center w-full rounded-lg text-[2.5vh] text-[#484848] py-1 px-2 focus:outline-none focus:ring-0 focus:border-smd_golden-light" onChange={e => setLanguage(e.target.value)} defaultValue={language}>
                                        <option value="" disabled>Select language</option>
                                        <option value="english">English</option>
                                        <option value="telugu">Telugu</option>
                                        <option disabled value="hindi">Hindi - Coming Soon</option>
                                    </select>
                                </div>
                            </div>
                            <div className="space-y-2">
                                <p className="text-[2vh]">Begin your live demo — just 5 mins to explore.</p>

                                <div className="flex justify-center">
                                    <button
                                    disabled={!language}
                                        // onClick={() => navigate("/explore/communication/poor-comm")}
                                        onClick={() => navigate("/explore/how-to-achive")}
                                        className={`flex items-center gap-2 font-inter text-[2.5vh] font-light bg-[#CB0404] text-gray-100 px-8 py-2 rounded-xl hover:bg-[#7FBC00] transition-colors duration-300 shadow-2xl shadow-[black] ${!language && "cursor-not-allowed"}`}
                                    >
                                        Experience Demo
                                        <Lottie animationData={CircularRightArrow} className="-rotate-90 h-[5vh]" />
                                    </button>
                                </div>
                            </div>
                            <div className="flex justify-center items-center">
                                <p className="text-[2.2vh] text-smd_blue-normal text-center">Want to know more? visit <a href="https:www.soomuch.ai" target="_blank" className="inline font-inter text-smd_blue-dark font-manropeSB">www.soomuch.ai</a></p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2  gap-[1.5vh]">
                            {LIST?.slice(4)?.map((item, index) => <div key={"asdbasbdnasmdasd" + index} className="bg-[white] drop-shadow-2xl rounded-xl p-3 text-[#081B34] text-left space-y-4 min-h-[22vh]">
                                <div className="w-fit p-[1vh] rounded-full bg-smd_white-normal border-2 border-[#FBF1E7]">
                                    <Img src={item?.image} className="object-cover h-[4vh]" />
                                </div>
                                <h2 className="text-[2.2vh] text-[black]">{wrapStrong(item?.title)}</h2>
                            </div>)}
                        </div>
                    </div>

                </div>
                <div></div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-4 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="col-span-8 text-center self-end space-y-2">
        //                     <h1 className="font-raveo text-smd_blue-normal text-2xl font-[1000] leading-[120%] tracking-[-1%]">India's First Business Platform For Schools built just for you</h1>
        //                     <p className="text-sm">We combined the best school business ideas from worldwide to create a simple 5-step system that helps schools grow fast and save big!</p>
        //                 </div>
        //                 <div className="col-span-2 flex justify-end">
        //                     <AvatarVideo videoRef={videoRef} videoLinks={videoLinks} />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="mt-6">
        //             <div className="grid grid-cols-3 gap-4">
        //                 <div className="col-span-3">
        //                     <h2 className="font-manropeSB text-xl text-center text-smd_blue-normal">Your big benefits</h2>
        //                 </div>
        //                 <div style={cardStyle}>
        //                     <h2 className="font-manropeSB text-lg text-center text-smd_blue-normal">Up to ₹2.5 Crores Admissions Growth</h2>
        //                     <div className="flex-grow flex items-center justify-center py-4">
        //                         <Img src="images/soomuch-demo/Growth.png" className="w-[10rem] h-[8rem]" alt="Growth" />
        //                     </div>
        //                 </div>

        //                 <div style={cardStyle}>
        //                     <h2 className="font-manropeSB text-lg text-center text-smd_blue-normal">Up to ₹25 Lakhs Saved from outdated school software</h2>
        //                     <div className="flex-grow flex items-center justify-center py-4">
        //                         <Img src="images/soomuch-demo/Card2.png" className="w-[10rem] h-[8rem]" alt="Savings" />
        //                     </div>
        //                 </div>

        //                 <div style={cardStyle}>
        //                     <h2 className="font-manropeSB text-lg text-center text-smd_blue-normal">Up to 4000+ Hours Saved (worth Approx ₹5 Lakhs in salaries!)</h2>
        //                     <div className="flex-grow flex items-center justify-center py-4">
        //                         <Img src="images/soomuch-demo/Image3.png" className="w-[10rem] h-[8rem]" alt="Time savings" />
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="flex justify-center items-center mt-5">
        //                 <p className="mb-1 text-smd_blue-normal text-center ">Want to know more? visit <a href="https://www.soomuch.ai" target="_blank" className="text-smd_blue-dark font-manropeSB">www.soomuch.ai</a></p>
        //             </div>
        //         </div>
        //         <div className="text-center">
        //             <button
        //                 onClick={() => navigate("/explore/communication/poor-comm")}
        //                 className="tracking-wide bg-smd_blue-normal text-white font-medium px-8 py-3 rounded-xl hover:bg-smd_blue-dark transition-colors duration-300"
        //                 style={{ color: "white" }}
        //             >
        //                 Demo Starts Here
        //             </button>
        //         </div>
        //     </div>
        //     {showModal && (
        //         <div className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-md flex items-center justify-center z-50">
        //             <div className="relative bg-gradient-to-br from-smd_blue-dark to-indigo-900 rounded-xl p-8 max-w-md w-full text-center shadow-2xl border border-indigo-400/30">
        //                 <div className="absolute -top-10 -left-10 w-20 h-20 bg-smd_blue-light rounded-full opacity-20 blur-md"></div>
        //                 <div className="absolute -bottom-8 -right-8 w-16 h-16 bg-smd_golden-light rounded-full opacity-20 blur-md"></div>

        //                 <Img src="images/soomuch-demo/logo.svg" className="h-10 mb-4 mx-auto" />

        //                 <h2 className="text-3xl font-bold mb-3 text-white" style={{ color: "white" }}>Welcome to Soomuch!</h2>

        //                 <p className="mb-6 text-gray-100 text-lg">
        //                     Create your school's online presence in just minutes with our
        //                     <span className="text-smd_golden-light font-manropeSB"> AI-powered design!</span>
        //                 </p>

        //                 <button
        //                     onClick={() => {
        //                         setShowModal(false);
        //                         setVideoPlaying(true);
        //                     }}
        //                     className="bg-smd_golden-light text-white font-manropeSB px-8 py-3 rounded-lg hover:bg-smd_golden-normal transition-all duration-300 shadow-lg transform hover:scale-105 hover:shadow-xl"
        //                 >
        //                     Yes, Let's Begin!
        //                 </button>

        //                 <div className="mt-4 text-gray-300 text-sm">
        //                     Ready to transform your school's digital presence?
        //                 </div>
        //             </div>
        //         </div>
        //     )}
        // </div>
    );
}

export default Intro;